import { render, staticRenderFns } from "./MappingDetails.vue?vue&type=template&id=40d55a2a&"
import script from "./MappingDetails.vue?vue&type=script&lang=ts&"
export * from "./MappingDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports